import { render, staticRenderFns } from "./RelatedTest.vue?vue&type=template&id=213b89d5&scoped=true"
import script from "./RelatedTest.vue?vue&type=script&lang=js"
export * from "./RelatedTest.vue?vue&type=script&lang=js"
import style0 from "./RelatedTest.vue?vue&type=style&index=0&id=213b89d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213b89d5",
  null
  
)

export default component.exports